module.exports = __webpack_public_path__ + "img/ic_profile.05c95a4c.svg";